import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DashboardsModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/dashboards.module';
import { DataSourceModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/data-source/data-source.module';
import { SmartGridModule } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/smart-grid/smart-grid.module';
import { environment } from '$env';
import { OverviewReportComponent } from './components/overview-report/overview-report.component';
import { MonthlyReportComponent } from './components/monthly-report/monthly-report.component';
import { AnalystReportComponent } from './components/analyst-report/analyst-report.component';
import { MySamplesReportComponent } from './components/my-samples-report /my-samples-report.component';

@NgModule({
  imports: [
    CommonModule,
    DashboardsModule.forRoot({
      dataServiceApi: environment.cprServiceApi,
    }),
    DataSourceModule.forRoot({
      dataServiceApi: environment.cprServiceApi,
    }),
    SmartGridModule,
  ],
  declarations: [
    OverviewReportComponent,
    MonthlyReportComponent,
    AnalystReportComponent,
    MySamplesReportComponent,
  ],
  exports: [
    OverviewReportComponent,
    MonthlyReportComponent,
    AnalystReportComponent,
    MySamplesReportComponent,
  ],
})
export class ReportsComponentsModule {}
